import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string().email('E-mail inválido').required('Campo obrigatório'),
});
